import React from "react";
import {
  HomeContainer,
  HomeBackground,
  HomeTitle,
  SectionsContainer,
  LinkR,
  LinkContainer,
  ArrowBeer,
  TitleDecoration,
  Popup,
  PopupButton,
  PopupImage,
  PopupContainer,
} from "./HomeElements";
import { ReturnButton } from "./SectionElements";
import { MdLanguage } from "react-icons/md";
import { IoMdClose } from "react-icons/io";

const Home = ({ menuSections, toggle, setToggle, language, onLanguageReset, popupImg }) => {

  const imageHash = Date.now();

  return (
    <>
      <HomeContainer>
        {/* Botón de idioma estilo ReturnButton */}
        <ReturnButton
          as="button"
          style={{
            left: 20,
            right: "auto",
            position: "fixed",
            top: 20,
            zIndex: 10,
            background: "rgba(0,0,0,0.5)",
            border: "none",
            cursor: "pointer",
          }}
          onClick={onLanguageReset}
        >
          <MdLanguage />
        </ReturnButton>
        <Popup toggle={toggle}>
          <PopupContainer>
            <PopupButton
              onClick={() => {
                setToggle(false);
              }}
            >
               <IoMdClose />
            </PopupButton>
            <PopupImage>
              <img src={`${popupImg}?${imageHash}`} alt="promotion" />
            </PopupImage>
          </PopupContainer>
        </Popup>
        <HomeBackground />
        <HomeTitle>
          {language === "es" ? "Menu digital" : "Digital Menu"}
        </HomeTitle>
        <SectionsContainer>
          {menuSections.map((item, index) => (
            <LinkContainer key={index} special={item.special}>
              <LinkR to={`/${item.route}`}>
                <h2>{item.name}</h2>
                {item.burger && <TitleDecoration />}
                {item.beer && <ArrowBeer />}
              </LinkR>
            </LinkContainer>
          ))}
        </SectionsContainer>
      </HomeContainer>
    </>
  );
};

export default Home;
